export type ServiceStatusCount = {
  key: "done" | "canceled" | "onHold";
  label: string;
  count: number;
};

export type ServicePopularityMetrics = {
  totalRevenue: number;
  guestsUsedPercent: number | null;
  statusCounts: ServiceStatusCount[];
};

export type DailyRevenuePoint = {
  day: string;
  revenue: number;
};

export type DiscountImpactPoint = {
  label: string;
  revenue: number;
  discount: number;
};

export type ServiceReviewRow = {
  id: string;
  guestName: string;
  countryCode: string;
  responsibility: string;
  feedbackTime: string;
  feedback: string;
  rating: number;
};

export type ServiceReviewSummary = {
  overallRating: number;
  positiveNeutralPercent: number;
  negativePercent: number;
  reviewsCount: number;
};

export type ServiceDetailExtras = {
  operatingHours: string;
  priceLabel: string;
  heroPhotoId?: string | null;
  heroImageUrl?: string;
};

export type ServiceDetailAnalytics = {
  popularity: ServicePopularityMetrics;
  dailyRevenue: DailyRevenuePoint[];
  revenueTrendLabel: string;
  revenueTrendSubtext: string;
  revenueHighlightDay?: string;
  discountImpact: DiscountImpactPoint[];
  discountSavedPercent: number;
  discountTotalProfit: number;
  reviewSummary: ServiceReviewSummary;
  reviews: ServiceReviewRow[];
};

export const EMPTY_SERVICE_REVIEWS: Pick<
  ServiceDetailAnalytics,
  "reviewSummary" | "reviews"
> = {
  reviewSummary: {
    overallRating: 0,
    positiveNeutralPercent: 0,
    negativePercent: 0,
    reviewsCount: 0,
  },
  reviews: [],
};

export const SERVICE_REVIEWS_PAGE_SIZE = 7;
